import { FiBook, FiUsers, FiZap, FiBarChart2 } from 'react-icons/fi';

const audiences = [
  {
    Icon: FiBook,
    title: 'Law Firms',
    desc: 'Engagement letters, NDAs, and client agreements with Aadhaar-verified signatures and court-admissible evidence records.',
  },
  {
    Icon: FiUsers,
    title: 'HR Teams',
    desc: 'Offer letters, onboarding forms, and employment contracts signed in minutes — with a complete audit trail.',
  },
  {
    Icon: FiZap,
    title: 'Startups',
    desc: 'Investor agreements, vendor contracts, and cap table documents — legally watertight from day one.',
  },
  {
    Icon: FiBarChart2,
    title: 'Finance & Compliance',
    desc: 'Loan documents, KYC forms, approvals, and regulated documentation with full evidence and timestamp records.',
  },
];

export default audiences;
